import { render, staticRenderFns } from "./EBSFormula.vue?vue&type=template&id=e8efc9b8&scoped=true"
import script from "./EBSFormula.vue?vue&type=script&lang=js"
export * from "./EBSFormula.vue?vue&type=script&lang=js"
import style1 from "./EBSFormula.vue?vue&type=style&index=1&id=e8efc9b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8efc9b8",
  null
  
)

export default component.exports